<template>
  <EnterpriseDescriptionView mode="collaborator" />
</template>

<script setup>
import EnterpriseDescriptionView from "@/views/enterprises/EnterpriseDescriptionView.vue";
</script>
